__turbopack_context__.v({
  "announce": "Header-module__6fFKIG__announce",
  "buttonRow": "Header-module__6fFKIG__buttonRow",
  "content": "Header-module__6fFKIG__content",
  "demoButton": "Header-module__6fFKIG__demoButton",
  "demoHidden": "Header-module__6fFKIG__demoHidden",
  "demoToggleButton": "Header-module__6fFKIG__demoToggleButton",
  "demoVisible": "Header-module__6fFKIG__demoVisible",
  "hypersphereBackground": "Header-module__6fFKIG__hypersphereBackground",
  "placeholder": "Header-module__6fFKIG__placeholder",
  "searchui": "Header-module__6fFKIG__searchui",
  "tagline": "Header-module__6fFKIG__tagline",
  "textColumn": "Header-module__6fFKIG__textColumn",
  "textContent": "Header-module__6fFKIG__textContent",
  "title": "Header-module__6fFKIG__title",
  "wrapper": "Header-module__6fFKIG__wrapper",
});
